export type EarlyFeatureCode = (typeof EarlyFeatureCodeValues)[number];
export const EarlyFeatureCodeValues = [
  'dev-example',
  'enable-tour-mode',
  'enable-tour-import-orfeo',
  'import-tgs',
] as const;
